// ================= WHAT A SEASONAL CARD COSTS — THE CLIENT'S COPY =================
//
// A mirror of lib/store/catalog.js, which is the authority. This copy exists so the library screen
// can print a price beside a card the moment it renders, rather than after a round trip — and so a
// build with no accounts at all can still say what the season contains.
//
// IT NEVER DECIDES WHAT IS CHARGED. `POST /api/store/purchase` looks the price up server-side and
// ignores anything the body says about it; the response carries the balance that actually resulted.
// If these two files ever disagree, the player is charged the server's number and this one was a
// label that was briefly wrong on screen.
//
// The two are held equal by tests/store-catalog-test.js, not by discipline — see the header of
// lib/store/catalog.js, and js/credit-rules.js for the same arrangement one feature earlier.
window.STORE_CATALOG = (function () {
  'use strict';

  const SEASONAL_CARD_PRICE = 50;
  const SEASON_ID = 'scenes-from-summer-2026';

  const CATALOG_IDS = [
    'sfs_level_change_cross',
    'sfs_long_guard_spear_elbow',
    'sfs_gedan_barai_counter',
    'sfs_step_behind_hook_kick',
    'sfs_jut_sao_straight',
    'sfs_reverse_elbow',
    'sfs_slide_by',
    'sfs_uki_otoshi',
    'sfs_rebound_front_kick',
    'sfs_compact_frame',
    'sfs_split_gate_entry',
    'sfs_two_on_one_turn',
    'sfs_sprawl_and_rise',
    'sfs_split_the_guard',
    'sfs_smothering_clinch'
  ];

  // Null, not a default price — the same distinction the authority draws, for the same reason: a
  // fallback would put a price tag on the 194 cards every player already owns.
  function priceOf(cardId) {
    return CATALOG_IDS.indexOf(cardId) >= 0 ? SEASONAL_CARD_PRICE : null;
  }

  function isForSale(cardId) {
    return priceOf(cardId) !== null;
  }

  function catalog() {
    return CATALOG_IDS.map(function (id) { return { cardId: id, price: SEASONAL_CARD_PRICE }; });
  }

  return {
    SEASONAL_CARD_PRICE: SEASONAL_CARD_PRICE,
    SEASON_ID: SEASON_ID,
    CATALOG_IDS: CATALOG_IDS,
    priceOf: priceOf,
    isForSale: isForSale,
    catalog: catalog
  };
})();
